import { SettingsIdValues } from "@octopusdeploy/octopus-server-client";
import React from "react";
import { EditSettingsPage } from "~/areas/configuration/components/Settings/EditSettingsPage";
export function ServiceNowIntegrationSettingsPage() {
    return <EditSettingsPage settingId={SettingsIdValues.ServiceNowIntegration}/>;
}
